<div
  [class]="data.type"
  class="snackbar-container"
  [style.gap.px]="messages.length === 1 ? 12 : 24"
>
  <ui-svg-icon [svgIcon]="getIcon(data.type)"></ui-svg-icon>
  <div class="messages">
    <ng-container *ngIf="messages.length > 1; else singleMsg">
      <ul>
        <li *ngFor="let msg of messages">{{ msg }}</li>
      </ul>
    </ng-container>
    <ng-template #singleMsg>
      <div>
        {{ messages[0] }}
        <span *ngIf="remainingSeconds">({{ remainingSeconds }}s)</span>
      </div>
    </ng-template>
  </div>
  <span class="close-btn" (click)="close()">
    <ui-svg-icon svgIcon="close" size="large"></ui-svg-icon>
  </span>
</div>
